import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matbutton',
	templateUrl:'./MatButtonPage.html',
	styles: [],
	styleUrls:['./MatButtonPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatButtonPage
{
	mdContent_240 = `\`\`\`java
import com.jwebmp.plugins.angular.material.MatButton;
\`\`\``;
	mdContent_241 = `\`\`\`java
MatButton()
\`\`\``;
	mdContent_242 = `\`\`\`java
MatButton(String text)
\`\`\``;
	mdContent_243 = `\`\`\`java
MatButton&lt;?&gt; btn = new MatButton&lt;&gt;("Submit");
btn.setColor("primary");
btn.setRaised(true);
\`\`\``;
}
